import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MuiDialogActions from '@mui/material/DialogActions';
import TrainingIcon from '@mui/icons-material/School';
import { styled } from '@mui/material/styles';

import Button from '../shared/Button';

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    width: '450px',
  },
}));

const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
}));

const TrainingModeModal = (props) => {
  const {
    open,
    title,
    text,
    additionalText,
    onSubmit,
    onClose,
    submitText,
  } = props;

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && (
        <DialogTitle id="alert-dialog-title" sx={{ mt: '8px', display: 'flex', alignItems: 'center' }}>
          <TrainingIcon color="primary" sx={{ mr: 2 }}/>
          <span className="font-bold">{title}</span>
        </DialogTitle>
      )}

      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ fontWeight: 'bold', pt: '16px' }}
        >
          {text}
        </DialogContentText>

        {additionalText && (
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontWeight: 'bold', pb: '16px', pt: '8px' }}
          >
            {additionalText}
          </DialogContentText>
        )}
      </DialogContent>

      <DialogActions>
        <div className="d-flex flex-1 p-l-lg p-r-lg p-t-md p-b-md">
          <div
            className="flex-1 p-t-md p-b-md secondary pointer font-bold"
            onClick={onClose}
          >
            Cancel
          </div>
          <Button
            type="submit"
            text={submitText || 'Activate'}
            onClick={onSubmit}
          />
        </div>
      </DialogActions>
    </StyledDialog>
  );
};

TrainingModeModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  submitText: PropTypes.string,
  cancelText: PropTypes.string,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default TrainingModeModal;
